export default {
  borderRadius: 'medium',
  borderColor: 'brandOne100',
  captionBackgroundColor: 'brandOne10',
  headCellBorderColor: 'brandOne50',
  selectedColor: 'utilityWhite',
  accentColor: 'brandOne100',
  disabledColor: 'brandOne100',
  captionFontSize: 'small',
  navButtonSize: 'large',
} as const;
